import type { Price } from 'product-document-page-shared';

export const formatPrice = ({ amount, currency }: Price): string =>
    new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency',
        currency,
        currencyDisplay: 'code',
    })
        .format(amount / 100)
        .replace(/^(\S+)\s+(\S+)$/, '$2 $1');
